<ng-container *ngIf="user">
  <h1>
    Your Supply Chain
    <span class="second-title">SUPERCHARGED</span>
  </h1>
  <p class="tiles-title">
    Please Select One Of LYNNCO's Suite of Services Below
  </p>
  <div class="tiles" fxLayout="row wrap" fxLayoutGap="20pt">
    <!-- Suite Analytics New -->
    <a
      *ngIf="hasAccessTo('SA')"
      (click)="setUserGroup()"
      style="cursor: pointer"
    >
      <div class="tile">
        <div class="tile__logo sa-logo"></div>
        <div class="tile__text">
          Suite
          <span class="s-color sa-color">Analytics</span>
        </div>
      </div>
    </a>
    <!-- Suite Lynnco BI -->
    <a
      *ngIf="hasAccessTo('LBI')"
      (click)="redirectToLynncoBi()"
      style="cursor: pointer"
    >
      <div class="tile">
        <div class="tile__logo sa-logo"></div>
        <div class="tile__text">
          Lynnco
          <span class="s-color sa-color">BI</span>
        </div>
      </div>
    </a>
    <!-- Suite Search Old -->
    <a *ngIf="hasAccessTo('SSOLD')" routerLink="/suite-search/search">
      <div class="tile">
        <div class="tile__logo ss-logo"></div>
        <div class="tile__text">
          Suite
          <span class="s-color ss-color">Search DC</span>
        </div>
      </div>
    </a>

    <!-- Suite Search New -->
    <a *ngIf="hasAccessTo('SS')" routerLink="/new-suite-search/search">
      <div class="tile">
        <div class="tile__logo ss-logo"></div>
        <div class="tile__text">
          Suite
          <span class="s-color ss-color">Search</span>
        </div>
      </div>
    </a>

    <!-- Shipment Portal Old -->
    <form
      method="POST"
      action="{{ shipmentPortalUrl }}"
      target="_blank"
      ngNoForm
      *ngIf="
        user.mercuryUsername && user.mercuryPassword && hasAccessTo('SPOLD')
      "
    >
      <input
        type="hidden"
        id="UserName"
        name="UserName"
        [value]="user.mercuryUsername"
      />
      <input
        type="hidden"
        id="Password"
        name="Password"
        [value]="user.mercuryPassword"
      />
      <button type="submit" value="submit" class="cb">
        <div class="tile">
          <div class="tile__logo sp-logo"></div>
          <div class="tile__text">
            Shipment
            <span class="s-color sp-color">Portal Old</span>
          </div>
        </div>
      </button>
    </form>

    <!-- Shipment Portal New -->
    <a *ngIf="hasAccessTo('SP')" routerLink="/shipment-portal">
      <div class="tile">
        <div class="tile__logo sp-logo"></div>
        <div class="tile__text">
          Shipment
          <span class="s-color sp-color">Portal New</span>
        </div>
      </div>
    </a>

    <!-- Suite Link -->
    <a
      *ngIf="
        user?.mercuryUsername && user?.mercuryPassword && hasAccessTo('SL')
      "
      [href]="getSuiteLinkUrl()"
      target="_blank"
    >
      <div class="tile">
        <div class="tile__logo sl-logo"></div>
        <div class="tile__text">
          Suite
          <span class="s-color sl-color">Link</span>
        </div>
      </div>
    </a>
  </div>

  <div class="package"></div>
</ng-container>
